import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'

export default class Customers extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "ID",
				id: "pkey",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.pkey)
			},
			{
				Header: "Name",
				id: "name",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.name)
			},
			{
				Header: "Address",
				id: "customers_locations.street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (
					obj.customers_locationss
					&& obj.customers_locationss.length > 0
					&& obj.customers_locationss[0].street_1) ?
					obj.customers_locationss[0].street_1
					: ''
			},
			{
				Header: "City",
				id: "customers_locations.city",
				/** @param {Customers_Object} obj */
				accessor: obj => (
					obj.customers_locationss
					&& obj.customers_locationss.length > 0
					&& obj.customers_locationss[0].street_1) ?
					obj.customers_locationss[0].city  : ''
			},
			{
				Header: "State",
				id: "customers_locations.state",
				/** @param {Customers_Object} obj */
				accessor: obj => (
					obj.customers_locationss
					&& obj.customers_locationss.length > 0
					&& obj.customers_locationss[0].street_1) ?
					obj.customers_locationss[0].state : ''
			},
			{
				Header: "Zip",
				id: "customers_locations.zip",
				/** @param {Customers_Object} obj */
				accessor: obj => (
					obj.customers_locationss
					&& obj.customers_locationss.length > 0
					&& obj.customers_locationss[0].street_1) ?
					obj.customers_locationss[0].zip : ''
			},
			{
				Header: "Phone",
				accessor: "phone",
			},
			{
				Header: "Alternate Phone",
				accessor: "phone_alt",
			},
			{
				Header: "Email",
				accessor: "email",
			},
			{
				Header: "Referred",
				accessor: "referer",
			},
			{
				Header: "Region",
				id: "customers_locations.regions.name",
				/** @param {Customers_Object} obj */
				accessor: obj => obj.customers_locationss?.length ? obj.customers_locationss[0].regions.name : '',
				Cell: (props) => {
					let {original} = props;
					let {customers_locationss} = original;
					let name = customers_locationss?.length ? customers_locationss[0].regions.name : '';
					let pkey = customers_locationss?.length ? customers_locationss[0].regions.pkey : 0;

					if (!pkey) {
						return (
							<span>{name}</span>
						);
					}

					return (
						<span>
							<Link to={`/regions/${pkey}`}>
								{name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Notes",
				accessor: "notes",
			},
			{
				Header: "Created",
				accessor: "created",
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Customers_Object} obj */
				accessor: obj => obj.name,
				Cell: props => {
					return (
						<span data-cy={`edit-${props.original.name}`}>
							<Link to={"/customers/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customers')}
							{this.renderHeaderRight("Customers",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
